import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthHttpInterceptor, AuthModule } from '@auth0/auth0-angular';
import { environment as env, environment } from '../environments/environment';
import { BlankLayoutComponent } from './components/blank-layout/blank-layout.component';
import { DefaultLayoutComponent } from './components/default-layout/default-layout.component';
import authconfig from '../../auth_config.json';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import {MatDialogModule} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import { ConfirmDialogComponent } from 'src/shared/dialog/components/confirm-dialog/confirm-dialog.component';

@NgModule({
  declarations: [
    AppComponent,
    BlankLayoutComponent,
    DefaultLayoutComponent,
    ConfirmDialogComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    MatDialogModule,
    MatButtonModule,
    AuthModule.forRoot({      /// https://auth0.github.io/auth0-angular/interfaces/AuthConfig.html
      //...env.auth,
      domain: environment.auth.domain,     //'YOUR_AUTH0_DOMAIN',
      clientId: environment.auth.clientId, //'YOUR_AUTH0_CLIENT_ID',
      authorizationParams: {  /// https://auth0.github.io/auth0-angular/interfaces/AuthorizationParams.html
        redirect_uri: environment.auth.redirectUri, //window.location.origin,
        audience: environment.auth.audience,        //authconfig.audience,
        scope: 'openid profile email',
        redirectUri: environment.auth.redirectUri,
        logoutUri: environment.auth.logoutUri,
      },      
      httpInterceptor: {
        allowedList: [
          {
            uri: `${env.apiUrl}/*`,
            tokenOptions: {
              authorizationParams: {
                audience: environment.auth.audience,
                scope: 'openid profile email'
              }
            }
          }
        ],
      },
    }),
    BrowserAnimationsModule    
  ],
  providers:  [
    {
      provide : HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
